import { render, staticRenderFns } from "./StockInOut.vue?vue&type=template&id=04054e26"
import script from "./StockInOut.vue?vue&type=script&lang=js"
export * from "./StockInOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports